import api from "../api";
import config from "../config";

export const accountsService = {
  list: async () => {
    const token = localStorage.getItem("access_token");
    const res = await api.get(`${config.apiBaseUrl}/api/accounts/`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data?.results ?? res.data ?? [];
  },

  mySupervised: async () => {
    const token = localStorage.getItem("access_token");
    const res = await api.get(
      `${config.apiBaseUrl}/api/accounts/my-supervised/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  },

  create: async (payload) => {
    const res = await api.post(`/api/accounts/`, payload);
    return res.data;
  },

  createChild: async (parentId, payload) => {
    const res = await api.post(`/api/accounts/${parentId}/add-child/`, payload);
    return res.data;
  },

  getDetail: async (id) => {
    const res = await api.get(`/api/accounts/${id}/`);
    return res.data;
  },

  update: async (id, payload) => {
    const res = await api.patch(`/api/accounts/${id}/`, payload);
    return res.data;
  },

  remove: async (id) => {
    await api.delete(`/api/accounts/${id}/`);
  },

  listUsers: async (accountId, { includeInherited = false } = {}) => {
    const url = `/api/accounts/${accountId}/users/`;
    const res = includeInherited ? await api.get(url, { params: { include_inherited: 1 } }) : await api.get(url);
    return res.data?.results ?? res.data ?? [];
  },

  checkUserEmail: async (email) => {
    const res = await api.post(`/api/accounts/check-user-email/`, { email });
    return res.data;
  },

  findOrCreateUser: async (accountId, email, extras = {}) => {
    const res = await api.post(
      `/api/accounts/${accountId}/find-or-create-user/`,
      { email, ...extras },
    );
    return res.data;
  },

  addUser: async (accountId, userId, isAccountAdmin = false) => {
    const res = await api.post(`/api/accounts/${accountId}/add-user/`, {
      user_id: userId,
      is_account_admin: isAccountAdmin,
    });
    return res.data;
  },

  removeUser: async (accountId, userId) => {
    const res = await api.post(`/api/accounts/${accountId}/remove-user/`, {
      user_id: userId,
    });
    return res.data;
  },

  listManageableMailAccounts: async () => {
    const res = await api.get(`/api/accounts/mail-accounts/`);
    return res.data?.results ?? res.data ?? [];
  },
};

export const getDefaultAccountId = async () => {
  const accounts = await accountsService.list();
  return accounts?.[0]?.id ?? null;
};
